/* eslint-disable require-jsdoc */
import { PublicClientApplication, LogLevel } from '@azure/msal-browser';

/**
 * MSAL configuration for Azure AD authentication
 */
const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_CLIENT_ID_PROD,
    authority: import.meta.env.VITE_MICROSOFT_TENANT_URL,
    redirectUri: '/',
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
      },
      piiLoggingEnabled: false,
      logLevel: LogLevel.Verbose,
    },
  },
};

/**
 * Login request configuration with required scopes
 */
export const loginRequest = {
  scopes: ['openid', 'email', 'profile'],
};

/**
 * MSAL instance for authentication
 */
export const msalInstance = new PublicClientApplication(msalConfig);
